import {
  deleteContractProperty,
  clearContractPropertyAction,
} from 'actions/contracts/contractPropertyActions'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'

const ContractPropertyDelete = ({ formId, closeModal, selected }) => {
  //// HOOKS.
  const dispatch = useDispatch()

  //// GLOBAL STATE.

  //// LOCAL STATE.

  //// LIFECYCLE HELPERS.

  //// MEMOS.

  //// EFFECTS.
  useEffect(() => {
    return () => {
      dispatch(clearContractPropertyAction())
    }
  }, [dispatch])

  //// RENDER VARS & HELPERS.

  //// RENDER.
  return (
    <form
      id={formId}
      onSubmit={(e) => {
        e.preventDefault()
        dispatch(deleteContractProperty(selected))
        closeModal()
      }}
      className="form container"
    >
      <div>
        Are you sure you want to delete this contract property? This can not be
        undone.
      </div>
    </form>
  )
}

export default ContractPropertyDelete
